import { render, staticRenderFns } from "./ResultStrip.vue?vue&type=template&id=72405fbd&scoped=true&"
import script from "./ResultStrip.vue?vue&type=script&lang=js&"
export * from "./ResultStrip.vue?vue&type=script&lang=js&"
import style0 from "./ResultStrip.vue?vue&type=style&index=0&id=72405fbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72405fbd",
  null
  
)

export default component.exports